import { useTranslation } from "react-i18next";

import { useEnableGcpAccount } from "featureFlags/hooks/useEnableGcpAccount";
import { useEngineClusterFlag } from "featureFlags/hooks/useEngineClusterFlag";
import { WorkspaceEngine } from "services/engines/engine.types";

import { nodeTypeOptions } from "components/CreateEngine/constants";

import styles from "./EngineItemContent.module.scss";

type Props = {
  engine: WorkspaceEngine;
};

export const EngineItemContent = (props: Props) => {
  const { engine } = props;
  const { t } = useTranslation();
  const enabledGcpAccount = useEnableGcpAccount();
  const option = nodeTypeOptions.find(option => option.value === engine.type);
  const showEngineClusterFlag = useEngineClusterFlag();

  /* eslint-disable-next-line no-nested-ternary */
  const clustersRange = showEngineClusterFlag
    ? engine.minClusters !== engine.maxClusters
      ? `${engine.minClusters}-${engine.maxClusters}`
      : engine.minClusters
    : engine.clusters;

  const pluralCondition = showEngineClusterFlag
    ? engine.minClusters !== engine.maxClusters || engine.minClusters > 1
    : engine.clusters > 1;

  const plural = pluralCondition
    ? t("workspace.context_selector.clusters_plural")
    : t("workspace.context_selector.cluster");

  if (enabledGcpAccount) return null;

  return (
    <div className={styles.content}>
      <div className={styles.option}>{t(option?.name || "")}</div>
      <div className={styles.divider} />
      <div className={styles.option}>
        {clustersRange}&nbsp;
        {plural}
      </div>
      <div className={styles.divider} />
      <div className={styles.option}>
        {engine.nodes}&nbsp;
        {engine.nodes > 1
          ? t("workspace.context_selector.nodes_plural")
          : t("workspace.context_selector.node")}
      </div>
    </div>
  );
};
